import type { Router, LocationQueryRaw } from 'vue-router';
import NProgress from 'nprogress'; // progress bar

import { isLogin } from '@/utils/auth';

export default function setupUserLoginInfoGuard(router: Router) {
  router.beforeEach(async (to, from, next) => {
    NProgress.start();

    // 检查是否有token
    if (isLogin()) {
      // 有token，允许访问（权限检查由权限守卫处理）
      next();
    } else {
      // 没有token，检查是否是登录页
      if (to.name === 'login') {
        next();
        return;
      }
      // 跳转到登录页
      next({
        name: 'login',
        query: {
          redirect: to.name,
          ...to.query,
        } as LocationQueryRaw,
      });
    }
  });

  // 添加路由完成后的处理
  router.afterEach(() => {
    NProgress.done();
  });
}
